import { useBranchesGetAll } from "../../../fnx/branches/branchesGetAll";
import React, { useEffect } from "react";
export var useBranchData = function () {
    var _a = React.useState([]), listBranch = _a[0], setListBranch = _a[1];
    var _b = useBranchesGetAll(true), responseBranches = _b.responseBranches, loadingBranches = _b.loadingBranches, errorBranches = _b.errorBranches;
    useEffect(function () {
        if ((responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.length) > 0) {
            var newList = responseBranches.map(function (item) { return ({
                id: item.id,
                name: item.name,
                value: item.id,
            }); });
            setListBranch(newList);
        }
    }, [responseBranches]);
    return { listBranch: listBranch, errorBranches: errorBranches, loadingBranches: loadingBranches };
};
